export enum LvfDeliveryMode {
  NOT_SPECIFIED = 0,
  DIRECT_TO_REQUESTER = 1,
  DIRECT_TO_RECIPIENT = 2,
  SPECIFIED_AGENCY = 3,
  MANUAL_INPUT_ADDRESS = 4,
}
